import { IMeResponse } from "../types/api";

import { ApiResponse } from "../types/api";
import { apiClient, apiRequest } from "./api";

// Auth API calls
export const authApi = {
  // Me
  gameProfile: async (): Promise<IMeResponse> => {
    return apiRequest(() =>
      apiClient.get<ApiResponse<IMeResponse>>("/users/gameProfile")
    );
  },
};
